<div class="cnt-row main {{wrapItems ? 'wrap-main' : ''}}">

    <div *ngFor="let item of items"
        [attr.data-testid]="item.testId"
        class="cnt-row-centered item {{wrapItems ? 'wrap-item' : ''}} {{item.getInputValue() == value && !disabled ? 'selected-item' : ''}} {{disabled ? 'disabled-item' : ''}}"
        (click)="onSelect(item)"
        (mouseenter)="onItemEnter($event, item)"
        (mouseleave)="onItemLeave($event, item)"
        [style.marginRight.px]="itemSpace"
        [style.marginTop.px]="itemTopSpace"
    >

        <div class="itemtext h4Font">{{ item.label | translate }}</div>

    </div>

</div>
